import { useState } from "react";
import { useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import PatternsGrid from "./PatternsGrid";
import CampaignGrid from "./CampaignGrid";
import ResultGrid from "./ResultGrid.js";

export default function CustomerRetention() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [model, setModel] = useState();
  const [patterns, setPatterns] = useState();
  const location = useLocation();
  const [expanded, setExpanded] = useState(
    location.state && location.state.expanded
      ? location.state.expanded
      : "Campaign"
  );

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [{ name: msActiveMenu.pageTitle, url: "/customerretention" }],
      }}
    >
      <PatternsGrid
        expanded={expanded}
        setExpanded={setExpanded}
        setPatterns={setPatterns}
      />
      <CampaignGrid
        expanded={expanded}
        setExpanded={setExpanded}
        patterns={patterns}
        setModel={setModel}
      />
      {model ? (
        <ResultGrid
          CampaignID={model}
          setModel={setModel}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      ) : (
        ""
      )}
    </Detail>
  );
}
